import { useLocale } from '../i18n/LocaleContext';
import React from 'react';
import styled from 'styled-components';

const Video = ({
  videoId = 'GALLeg5Oexk',
  title,
  heading,
  description,
}) => {
  const { t } = useLocale();
  const embedSrc = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1`;

  return (
    <Section id="walkthrough" aria-labelledby="walkthrough-title">
      <Container>
        <Header>
          <Kicker>{title || t('video.title')}</Kicker>
          <Heading id="walkthrough-title">{heading || t('video.heading')}</Heading>
          <SubTitle>{description || t('video.description')}</SubTitle>
        </Header>

        <Player>
          <Iframe
            src={embedSrc}
            title={t("video.title")}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </Player>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  padding: 90px 0 110px;
  background: var(--light-gray);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 28px;
`;

const Kicker = styled.div`
  font-size: 2.2rem;
  text-align: center;
  margin-bottom: 10px;
  color: var(--primary);
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const Heading = styled.h2`
  font-size: 1.6rem;
  margin: 0 0 10px;
  color: var(--dark-gray);
`;

const SubTitle = styled.p`
  color: var(--secondary);
  max-width: 760px;
  margin: 0 auto;
`;

const Player = styled.div`
  position: relative;
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--shadow);

  /* 16:9 */
  padding-top: 56.25%;
`;

const Iframe = styled.iframe`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

export default Video;
